const testIds = {
  totalCount: 'total-count',
  footerTotalRoomCount: 'footer-total-room-count',
  footerTotalGuestCount: 'footer-total-guest-count',
  addRoomButton: 'add-room-button',
  countText: 'count-text',
  minusButton: 'minus-button',
  plusButton: 'plus-button',
};

export default testIds;
